import { useEffect } from 'react';

/**
 * A custom hook that checks the app version and reloads the page if a newer version is available.
 * This hook is used to ensure the user is always using the latest version of the application.
 */
export const useCacheClearWithAppVersion = () => {
  const checkVersion = async () => {
    try {
      const response = await fetch('/version.txt', { cache: 'no-store' });
      if (!response.ok) return;

      const latestVersion = (await response.text())?.trim();
      const storedVersion =
        typeof localStorage !== 'undefined' ? localStorage.getItem('appVersion') : null;

      // Trim whitespace from the stored version
      const trimmedStoredVersion = storedVersion ? storedVersion?.trim() : null;

      if (
        !trimmedStoredVersion ||
        (trimmedStoredVersion && trimmedStoredVersion !== latestVersion)
      ) {
        localStorage.setItem('appVersion', latestVersion);
        // Check if Cache API is available
        if ('caches' in window) {
          window.caches
            .keys()
            .then((cacheNames) => {
              return Promise.all(cacheNames.map((cache) => caches.delete(cache)));
            })
            .finally(() => {
              // Force a hard reload with cache bypass
              window.location.replace(window.location.href);
            });
        } else {
          // If Cache API is unavailable, do a normal refresh
          window.location.replace(window.location.href);
        }
      } else {
        localStorage.setItem('appVersion', latestVersion);
      }
    } catch (error) {
      console.error('Failed to fetch the latest version:', error);
    }
  };

  // Check immediately on mount
  useEffect(() => checkVersion(), []);

  return;
};
